var errorClass = 'error-gb';
var jqErrorClass = '.'+errorClass;
jQuery(function() {
  jQuery('#RequestOrderForm').submit(function(event) {
    var requestData = {
            Name: $.trim($('#RequestOrderForm-Name').val()),
            Email:$.trim($('#RequestOrderForm-Email').val()),
            PhoneNumber:$.trim($('#RequestOrderForm-PhoneNumber').val()),
            Course:$.trim($('#RequestOrderForm-Course').val()),
            NumberOfBooks:$.trim($('#RequestOrderForm-NumberOfBooks').val()),
            Notes:$.trim($('#RequestOrderForm-Notes').val()),
            CustomLeatherCoverRequired:($.trim($('#RequestOrderForm-CustomLeatherCoverRequired').val()))?1:0,
    }
    event.preventDefault();
    $(jqErrorClass).remove();
    var hasError = ''; 
    hasError += validateRequired('#RequestOrderForm-Name', 'Name');  
    var emailErr = validateRequired('#RequestOrderForm-Email', 'Email');
    hasError += emailErr;
    if (emailErr == '')
      	hasError += validateEmailFormat('#RequestOrderForm-Email', 'Email address', 'Specify a valid Email Address'); 
    //hasError += validateRequired('#RequestOrderForm-PhoneNumber', 'Phone Number');
    if(requestData.PhoneNumber !=""){
    	hasError += phone_validate('#RequestOrderForm-PhoneNumber', 'Phone Number'); 
    }
    if(hasError != '')
    {  setErrorClass();event.preventDefault();}   
    else{      
      
      jQuery.ajax({
          type: 'POST',
          url: 'https://api.golflogix.com/glx/resale/quote/ext',                 
          contentType: 'application/json',
          data:JSON.stringify(requestData),         
          dataType: 'json',            
          success: function (resData) {                
              if(resData.status !== 1){
               	console.log(resData.message);
              }
              else{               
                 jQuery('#OrderSuccess').removeClass('hide')                    
                          .html('Thanks for Resale Order, We will get back tou you.')
              }  
          },
          error: function (jqXhr, textStatus, errorMessage) {  
            console.log('Error: ' + errorMessage);       
          },
          complete : function(){
                jQuery('#RequestOrderForm')[0].reset();				
          }
      });  
    }    
  });
});
 function setErrorClass() {
   jQuery(jqErrorClass).css('color', 'red').css('font-size', '13px');
 }
 function validateRequired(field, label, message = '') {
   var err = '';
   if ($.trim($(field).val()) == '' || $.trim($(field).val()) == '0') {
     if (message == '')
       $(field).after('<div class="' + errorClass + '">Specify ' + label + '</div>');
     else
       showCustomErrorMsg(field, message, errorClass);
     err = 'error';
   }
   return err;
}
function validateEmailFormat(field, label, message = '') {
  var err = '';
  var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  if (!emailReg.test($.trim($(field).val()))) {
    if (message == '')
      $(field).after('<div class="' + errorClass + '">Specify a valid ' + label + '</div>');
    else
      showCustomErrorMsg(field, message, errorClass);
    err = 'error';
  }
  return err;
}
function showCustomErrorMsg(field, message,errorClass){
  $(field).after('<div class="' + errorClass + '">' + message + '</div>');
}
            